<template>
    <div class="modal-wrapper" v-if="!userData && !userData.first_name">
    <!-- <div class="modal-wrapper"> -->
        <div class="window">
            <div class="window-header">
                <h2 class="window-header__title">Введите ваше имя</h2>
            </div>
            <div class="window-body">
                <div class="input-group">
                    <div class="input">
                        <input
                            type="tel"
                            id="order_time"
                            v-model="userName"
                            ref="order_time"
                            placeholder="Иван"
                        />
                    </div>
                </div>
                <p v-if="errorText">{{ errorText }}</p>
                <button class="btn" @click="editFirstName()">Отправить</button>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/api";
import axios from "axios";
import { mapActions, mapState } from "vuex";

export default {
    data() {
        return {
            userName: '',
            errorText: "",
        };
    },
    computed: {
        ...mapState({
            isFirstName: (state) => state.isFirstName,
            userData: (state) => state.userData,
        }),
    },
    methods: {
        ...mapActions({
            getProfileData: "getProfileData",
        }),
        editFirstName() {
            this.errorText = ''
            if (this.userName != '') {
                const authToken = localStorage.getItem("token");

                axios
                    .post(
                        api + "projects/tcode/profile/",
                        {
                            first_name: this.userName,
                        },
                        {
                            headers: {
                                Authorization: "Token " + authToken,
                            },
                        },
                    )
                    .then((response) => {
                        if (response.status == 200) {
                            this.getProfileData();
                        } else {
                            this.errorText =
                                "Произошла ошибка! попробуйте позже";
                        }
                    });
            } else {
                this.errorText = 'Проверьте корректность данных!'
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.window {
    width: 400px;
    &-body {
        padding: 40px 20px 20px;
        p{
            color: var(--color-red);
        }
    }
    .input {
        input {
            border: none;
            outline: none;
            width: 100%;
        }
    }
    .btn {
        margin-top: 20px;
    }
}
</style>
